import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BookingFormValues } from '../../service/interfaces/Components';

const initialState: Partial<BookingFormValues> = {};

const bookingFormSlice = createSlice({
  name: 'bookingForm',
  initialState,
  reducers: {
    setBookingForm(state, action: PayloadAction<Partial<BookingFormValues>>) {
      return { ...state, ...action.payload };
    },
    setFullBookingForm(state, action: PayloadAction<BookingFormValues>) {
      return action.payload;
    },
    resetBookingForm() {
      return initialState;
    },
  },
});

export const { setBookingForm, setFullBookingForm, resetBookingForm } = bookingFormSlice.actions;
export default bookingFormSlice.reducer;